<template>
  <div class="form__logo"
       v-on:click="$emit('click')">
    <a :href="!editMode && $router.resolve({ name: 'user-profile' }).href">
      <img v-if="logoUrl"
           :src="logoUrl">
    </a>
  </div>
</template>

<script>
export default {
  props: ['logoUrl', 'editMode'],
};
</script>



// WEBPACK FOOTER //
// src/layout/HeaderLogo.vue